import { isValidElement } from "react";
import classNames from "classnames";

import { IconType, MuiIconComponent } from "./types";

const isMuiIconComponent = (icon: IconType): icon is MuiIconComponent =>
  typeof icon === "object" && "muiName" in icon.type?.render;

interface Props {
  icon: IconType;
  size: number;
}

const IconRenderer = ({ icon, size }: Props) => {
  if (isValidElement(icon)) {
    return (
      <div
        style={{ width: size, height: size }}
        className={classNames(
          "flex items-center justify-center overflow-hidden"
        )}
      >
        {icon}
      </div>
    );
  }

  if (isMuiIconComponent(icon)) {
    const IconComponent = icon;

    return <IconComponent style={{ fontSize: `${size}px` }} />;
  }

  return null;
};

export default IconRenderer;
